import { Card, Row, Col, Text, Flex } from "@/base/components/index";
import { SectionPage } from "@/components/section-page";
import { LocalizationText } from "@/app/index";
import { LocalizationDate } from "@/app/index";
import { FieldDisplay } from "@/components/field-display/index";
import { usePageContextInvoiceView } from "../../context/invoice-view-context";
import { useFormStyles } from "./form.styles";

export const ModuleForm = () => {
  const { styles } = useFormStyles();
  const { invoice } = usePageContextInvoiceView();

  return (
    <SectionPage
      classNames={{
        section: styles.section,
        body: styles.body,
      }}
    >
      <Flex gap={12} vertical>
        <Card>
          <Row gutter={[12, 12]}>
            <Col span={24}>
              <Text>Petrosoft LLC</Text>
            </Col>
            <Col span={24}>
              <Text>290 Bilmar Drive</Text>
            </Col>
            <Col span={24}>
              <Text>Pittsburgh, PA 15205</Text>
            </Col>
            <Col span={24}>
              <Text>(412) 306-0640</Text>
            </Col>
            <Col span={24}>
              <Text>info@petrosoftinc.com</Text>
            </Col>
          </Row>
        </Card>
        <Card>
          <Row gutter={[12, 12]}>
            {invoice?.BillTo && (
              <Col span={24}>
                <FieldDisplay
                  label={
                    <LocalizationText value="invoice.view.form.filed.label.bill.to" />
                  }
                  value={
                    <Text>{`${invoice?.BillTo}, ${invoice?.BillToPostalCode}, ${invoice?.BillToStateOrProvince}`}</Text>
                  }
                />
              </Col>
            )}

            {invoice?.ShipTo && (
              <Col span={24}>
                <FieldDisplay
                  label={
                    <LocalizationText value="invoice.view.form.filed.label.ship.to" />
                  }
                  value={
                    <Text>{`${invoice?.ShipTo}, ${invoice?.ShipToPostalCode}, ${invoice?.ShipToStateOrProvince}`}</Text>
                  }
                />
              </Col>
            )}

            {invoice?.Number && (
              <Col span={24}>
                <FieldDisplay
                  label={
                    <LocalizationText value="invoice.view.form.filed.label.number" />
                  }
                  value={<Text>{invoice?.Number}</Text>}
                />
              </Col>
            )}

            {invoice?.Created && (
              <Col span={24}>
                <FieldDisplay
                  label={
                    <LocalizationText value="invoice.view.form.filed.label.date" />
                  }
                  value={
                    <Text>
                      <LocalizationDate
                        value={invoice?.Created}
                        dateStyle="short"
                      />
                    </Text>
                  }
                />
              </Col>
            )}

            {invoice?.DueDate && (
              <Col span={24}>
                <FieldDisplay
                  label={
                    <LocalizationText value="invoice.view.form.filed.label.due.date" />
                  }
                  value={
                    <Text>
                      <LocalizationDate
                        value={invoice?.DueDate}
                        dateStyle="short"
                      />
                    </Text>
                  }
                />
              </Col>
            )}

            {invoice?.SalesOrder?.Number && (
              <Col span={24}>
                <FieldDisplay
                  label={
                    <LocalizationText value="invoice.view.form.filed.label.order" />
                  }
                  value={<Text>{invoice?.SalesOrder?.Number}</Text>}
                />
              </Col>
            )}
          </Row>
        </Card>
      </Flex>
    </SectionPage>
  );
};
